// extracted by mini-css-extract-plugin
export default {"summary":"_1KxcP","container":"_3Q2mF","info":"_2tWuN","title":"_20-8L","expandButton":"JHGoF","tickets":"_5dZK4","expanded":"_3GpzG"};